<template>
  <div
    v-loading="isLoading"
    class="vg_wrapper"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    element-loading-spinner="el-icon-loading"
    element-loading-text="正在加载中"
  >
    <el-row>
      <el-col :span="24" style="margin-bottom: 20px; margin-top: 10px">
        <div class="diagramTitle">
          <span style="font-size: 20px; margin-right: 10px">统计时间:</span>
          <div class="dateSelect">
            <el-date-picker v-model="daytime[0]" type="date"> </el-date-picker>
            <span style="font-size: 20px">至</span>
            <el-date-picker v-model="daytime[1]" type="date"> </el-date-picker>
          </div>
          <el-button class="buttonText" round size="mini" @click="timeScope(1)">近一月</el-button>
          <el-button class="buttonText" round size="mini" @click="timeScope(3)">近三月</el-button>
          <el-button class="buttonText" round size="mini" @click="timeScope(6)">近六月</el-button>
          <el-button class="buttonText" round size="mini" @click="timeScope(0)">全部</el-button>
          <el-button class="buttonText" round size="mini" type="primary" @click="getTableData()">查询</el-button>
          <el-button class="buttonText" round size="mini" type="info" @click="refresh">刷新</el-button>
          <el-button
            v-if="['徐礼明', '盖新', 'Admin'].includes($cookies.get('userInfo').stff_name)"
            class="buttonText"
            round
            size="mini"
            type="warning"
            @click="dialogVisible = true"
            >基础分调整
          </el-button>
          <el-button class="buttonText" round size="mini" type="success" @click="exportToExcel">导出Excel</el-button>
          <span class="vg_ml_8" style="font-size: 20px">TIPS:只可导出汇总！</span>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <search-table
        ref="searchTable"
        :cell-style="cellStyle"
        :columnMove="false"
        :columns="syncTableProperties"
        :data="tableData"
        :need-pagination="false"
        :needExpand="true"
        :tableRowKeyFunction="row => `${row.stff_name}${row.dept_name}${row.error_type}`"
        @getTableData="getTableData"
        @expand-change="getPartList"
      >
        <template v-slot:expand="scope">
          <el-card header="扣分明细">
            <search-table
              ref="searchTable2"
              :columnMove="false"
              :columns="syncTableProperties2"
              :data="tableData2"
              :fixed-height-param="400"
              :need-pagination="false"
              :needSearch="false"
              :tableRowKey="'id'"
            >
              <template v-slot:operation="{ row }">
                <el-link
                  class="vg_mr_8 vg_cursor"
                  size="mini"
                  type="primary"
                  @click="jump('/smpl_edit', { perm_id: 112, form_id: row.smpl_id })"
                  >查看详情
                </el-link>
              </template>
            </search-table>
          </el-card>
          <el-card header="加分明细">
            <search-table
              ref="searchTable3"
              :columnMove="false"
              :columns="syncTableProperties3"
              :data="tableData3"
              :fixed-height-param="400"
              :need-pagination="false"
              :needSearch="false"
              :tableRowKey="'id'"
            >
              <template v-slot:operation="{ row }">
                <el-link
                  class="vg_mr_8 vg_cursor"
                  size="mini"
                  type="primary"
                  @click="jump('/smpl_edit', { perm_id: 112, form_id: row.smpl_id })"
                  >查看详情
                </el-link>
              </template>
            </search-table>
          </el-card>
        </template>
      </search-table>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" title="基础分调整" top="50px" width="40%" @opened="getDialogData">
      <div class="vg_mb_8">
        <el-button class="buttonText" round size="mini" type="primary" @click="addDiffListData">新增</el-button>
        <el-button class="buttonText" round size="mini" type="danger" @click="delDiffListData">删除</el-button>
      </div>
      <search-table
        ref="searchTable4"
        :columnMove="false"
        :columns="dialogTableProperties"
        :data="dialogTableData"
        :fixedHeightParam="400"
        :need-fixed-height="false"
        :need-pagination="false"
        :need-search="true"
        :tableRowKey="'id'"
        @getTableData="getDiffListData"
        @selection-change="handleSelectionChange"
      />
      <div class="vg_mt_8" style="display: flex">
        <el-button class="buttonText" round size="mini" style="margin-left: auto" type="success" @click="editDiffListData">确定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTableV3.vue';
import { cloneDeep } from 'lodash';
import { keep1Decimal, keep3Decimal, keepNumber } from '@assets/js/regExUtil';
import { get, getNoCatch, postNoCatch } from '@api/request';
import { dataStaticsAPI } from '@api/modules/stat';
import { deleteTableRow2 } from '@assets/js/arrayUtils';
import { optnAPI } from '@api/modules/optn';

export default {
  components: { SearchTable },
  name: 'CorrectionStatistics',
  props: {
    module: {
      type: String
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      tableData2: [],
      syncTableProperties2: [
        {
          label: '委托打样单号',
          prop: 'error_count',
          itemType: 'input',
          input: false,
          sortable: false,
          widthAuto: true
        },
        { label: '样品编号', prop: 'error_type', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '操作', prop: 'operation', itemType: 'input', input: false, sortable: false, widthAuto: true }
      ],
      tableData3: [],
      syncTableProperties3: [
        {
          label: '委托打样单号',
          prop: 'error_count',
          itemType: 'input',
          input: false,
          sortable: false,
          widthAuto: true
        },
        { label: '样品编号', prop: 'error_type', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '操作', prop: 'operation', itemType: 'input', input: false, sortable: false, widthAuto: true }
      ],
      syncTableProperties: [
        { prop: 'index', type: 'index', labelWidth: '50px', label: '序号' },
        { label: '员工姓名', prop: 'stff_name', itemType: 'input', input: true, sortable: false, widthAuto: true },
        {
          label: '出错类型',
          prop: 'error_type',
          itemType: 'select',
          options: [],
          input: true,
          sortable: false,
          widthAuto: true
        },
        { label: '出错次数', prop: 'error_count', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '出错扣分', prop: 'deductPoints', itemType: 'input', input: false, sortable: false, widthAuto: true },
        {
          label: '发现问题次数',
          prop: 'correct_count',
          itemType: 'input',
          input: false,
          sortable: false,
          widthAuto: true
        },
        { label: '纠错加分', prop: 'bonusPoints', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '总得分', prop: 'totalScore', itemType: 'input', input: false, sortable: true, widthAuto: true }
      ],
      dialogTableProperties: [
        { prop: 'selection', type: 'selection', labelWidth: '48px' },
        { prop: 'index', type: 'index', labelWidth: '50px', label: '序号' },
        {
          label: '出错类型',
          prop: 'wrong_type',
          itemType: 'input',
          input: true,
          subItem: {
            type: 'select',
            options: [],
            change: (val, row) => {
              if (this.dialogTableData.filter(item => item.wrong_type === val).length > 1) {
                row.wrong_type = '';
                return this.$message.error('出错类型不可重复');
              }
            }
          }
        },
        {
          label: '出错扣分',
          prop: 'deduct_points',
          itemType: 'input',
          input: false,
          subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.deduct_points = keep1Decimal(val)) }
        },
        {
          label: '纠错加分',
          prop: 'bonus_points',
          itemType: 'input',
          input: false,
          subItem: { type: 'input', maxLength: 3, input: (val, row) => (row.bonus_points = keep1Decimal(val)) }
        }
      ],
      tableData: [],
      dialogTableData: [],
      selectionsList: [],
      startTime: null,
      endTime: null,
      daytime: '',
      dialogVisible: false,
      isLoading: this.loading,
      errorList: []
    };
  },
  computed: {},
  watch: {
    module(newValue, oldValue) {
      let list = this.errorList.find(x => x.param1 === newValue)?.param2.split('/*/') || [];
      let temp = list.map(x => ({ value: x, label: x }));
      this.dialogTableProperties.find(item => item.prop === 'wrong_type').subItem.options = temp;
      this.syncTableProperties.find(item => item.prop === 'error_type').options = temp;
    }
  },
  mounted() {
    this.timeScope(1);
    this.getOptnByPermIdErr();
  },
  methods: {
    keep3Decimal,
    keepNumber,
    keep1Decimal,
    initData() {
      this.getTableData();
    },
    getSearchForm() {
      let searchForm = cloneDeep(this.$refs.searchTable.searchForm);
      searchForm.type = 2;
      const [startTime, endTime] = cloneDeep(this.daytime || []);
      // 确保时间戳被正确赋值且进行单位转换（如果需要）
      searchForm.start_time = startTime ? Math.floor(startTime / 1000) : null;
      let secondDate = new Date(endTime);
      secondDate.setHours(23, 59, 59, 999);
      searchForm.end_time = endTime ? Math.floor(secondDate.getTime() / 1000) : null;
      searchForm.module = this.module;
      searchForm.dept_name = this.$cookies.get('userInfo').dept_name;
      searchForm.isExport = true;
      console.log(searchForm);
      
      searchForm.stff_name =  searchForm.employee_name || null;
      return searchForm;
    },
    getTableData() {
      this.isLoading = true;
      get(dataStaticsAPI.processStatisticsyz, this.getSearchForm()).then(({ data }) => {
        if (data.code === 0) {
          this.tableData = data.data.list;
          this.isLoading = false;
        }
      });
    },
    refresh() {
      this.startTime = null;
      this.endTime = null;
      this.daytime = '';
      this.initData();
    },
    // 导出excel
    exportToExcel() {
      getNoCatch(dataStaticsAPI.excelProcessStatistics, this.getSearchForm()).then(({ data }) => {
        this.helper.downloadItemExcel(data.url, data.fileName);
      });
    },
    getDialogData() {
      this.getDiffListData();
    },
    getOptnByPermIdErr() {
      get(optnAPI.getOptnByPermId, { perm_id: 10017 })
        .then(res => {
          if (res.data.code === 0) {
            this.errorList = res.data.data.form.optn_cntt_list;
            let list = this.errorList.find(x => x.param1 === this.module)?.param2.split('/*/') || [];
            let temp = list.map(x => ({ value: x, label: x }));

            this.dialogTableProperties.find(item => item.prop === 'wrong_type').subItem.options = temp;
            this.syncTableProperties.find(item => item.prop === 'error_type').options = temp;
            return;
          }
          this.$message.error(res.data.msg);
        })
        .catch(res => {
          this.$message.error(res);
        });
    },
    handleSelectionChange(selection) {
      this.selectionsList = [];
      this.selectionsList = selection;
    },
    getDiffListData() {
      let searchForm = cloneDeep(this.$refs.searchTable4.searchForm);
      searchForm.saml_product = this.module;
      searchForm.belo_dept_id = this.$cookies.get('userInfo').dept_id;
      getNoCatch(dataStaticsAPI.getBasicScoreMaintenance, searchForm).then(({ data }) => {
        this.dialogTableData = data;
        this.subTableMap = new Map();
      });
    },
    editDiffListData() {
      let data = cloneDeep(this.dialogTableData).concat(Array.from(this.subTableMap.values()));
      postNoCatch(dataStaticsAPI.editBasicScoreMaintenance, data).then(({ data }) => {
        this.dialogVisible = false;
        this.$message.success('操作成功!');
      });
    },
    addDiffListData() {
      let userInfo = this.$cookies.get('userInfo');
      this.dialogTableData.push({
        belo_dept_id: userInfo.dept_id,
        belo_dept_name: userInfo.dept_name,
        saml_product: this.module,
        bonus_points: 1,
        deduct_points: 1
      });
    },
    delDiffListData() {
      if (this.selectionsList.length < 1) {
        return this.$message.error('请至少选择一条数据！');
      }
      let { tableData, map } = deleteTableRow2('id', this.dialogTableData, this.subTableMap, this.selectionsList);
      this.dialogTableData = tableData;
      this.subTableMap = map;
    },
    timeScope(val) {
      let firstDate = new Date();
      firstDate.setMonth(firstDate.getMonth() - val);
      firstDate.setDate(26);
      firstDate.setHours(0, 0, 0, 0);
      let secondDate = new Date();
      secondDate.setDate(25);
      secondDate.setHours(23, 59, 59, 999);
      this.daytime = val === 0 ? [] : [Math.floor(firstDate.getTime()), Math.floor(secondDate.getTime())];
      this.getTableData();
    },
    getPartList(val) {
      let searchForm = {};
      searchForm.start_time = Math.floor(this.startTime);
      searchForm.end_time = Math.floor(this.endTime);
      searchForm.error_type = val.error_type;
      searchForm.stff_name = val.stff_name;
      searchForm.module = this.module;
      get(dataStaticsAPI.getErrorCorrectionDetails, searchForm).then(({ data }) => {
        if (data.code === 0) {
          this.tableData2 = data.data.errorDetails; //扣分
          this.tableData3 = data.data.bonusPointsDetails; //加分
        }
      });
    },
    cellStyle({ row, column }) {
      switch (column.label) {
        case '出错次数':
        case '出错扣分':
          return { color: 'red' };
        case '发现问题次数':
        case '纠错加分':
          return { color: 'green' };
        case '总得分':
          return row[column.property] <= 0 ? { color: 'red' } : { color: 'green' };
      }
    }
  }
};
</script>

<style scoped>
.diagramTitle {
  display: flex;
  align-items: center;
}

.dateSelect {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.buttonText {
  font-size: 18px;
}
</style>
